import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  WritableSignal,
  input,
  signal,
  inject,
} from '@angular/core';
import { AbstractControl, FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { dateRangeValidator } from '@shared/validators/date-range-validator';
import moment from 'moment';

@Component({
  standalone: false,
  selector: 'gstar-security-action-date-modal',
  templateUrl: './security-action-date-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SecurityActionModalComponent implements OnInit {
  private readonly formBuilder = inject(FormBuilder);
  private readonly translateService = inject(TranslateService);

  title = input<string>('');
  content = input<string>('');
  placeHolderSecurityDateField = input<string>('');
  isChangeToAcquire = input<boolean>();
  isAcquire = input<boolean>();
  modalId = input<string>('');
  acquisitionDate = input<Date>();
  creationDate = input<Date>();

  @Input() confirmationFn?: (date?: Date) => void;

  incorrectDateErrorMessagge!: string;
  hasSelectedDate: WritableSignal<boolean> = signal(false);
  securityForm = this.formBuilder.group({
    securityDateField: {} as Date[],
  });

  get securityDateField(): AbstractControl<Date[]> {
    return this.securityForm.get(
      'securityDateField'
    )! as unknown as AbstractControl<Date[]>;
  }

  ngOnInit(): void {
    this.incorrectDateErrorMessagge = this.isChangeToAcquire()
      ? this.translateService.instant(
          'upsertSecurity.acquisitionDateValidation'
        )
      : this.isAcquire()
        ? this.translateService.instant(
            'upsertSecurity.disposeDateAcquisitionSecurityValidation'
          )
        : this.translateService.instant(
            'upsertSecurity.disposeDatePreClearSecurityValidation'
          );
    if (this.isChangeToAcquire()) {
      this.securityDateField.setValue([moment().toDate()]);
      this.securityDateField.setValidators(dateRangeValidator());
      this.hasSelectedDate.set(true);
    } else {
      this.securityDateField.setValidators(
        dateRangeValidator({
          minDate: this.isAcquire()
            ? this.acquisitionDate()
            : this.creationDate(),
          maxDate: moment().toDate(),
        })
      );

      this.securityDateField.valueChanges.subscribe((date: Date[] | null) => {
        this.hasSelectedDate.set(date?.length !== 0);
      });
    }
    this.securityDateField.valueChanges.subscribe(value =>
      this.hasSelectedDate.set(value.length === 0 ? false : true)
    );
  }

  confirm(): void {
    this.confirmationFn?.(this.securityDateField?.value[0]);
  }

  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
    }
  }
}
